import { ConnectionTabContent } from "@/entities/connectio-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsConnectionsRouteV2: RouteProps = {
  path: appRouterPaths.contacts.connections,
  element: <ConnectionTabContent />,
};
